
export const ElementStyles={
  paddingLabels: "2px 5px 2px 5px",
  borderRadius: "10px",
  color: "var(--white)",
  color2: "var(--background)",
  color3: "var(--darkgray)",
  accent: "var(--accent)",
  height: "28px"

}

export const BackgroundElementStyles={
  paddingLabels: "2px 5px 2px 5px",
  borderRadius: "10px",
  background: "var(--darkgray)",
  backgroundPast: "#222833",
  color: "#fff",
  height: "28px"

}

